// TopQuestions component - displays most frequently asked questions
// Shows a numbered list of top questions with count


/**
 * 
 * NOTES SUMMARY - TOP QUESTIONS USERS ASK
 * 
 * 
 * 
 */



import React from 'react';
import '../../styles/components.css';

function TopQuestions({ questions }) {
  return (
    <div className="top-questions-section">
      <h2>Top Questions Asked</h2>
      {questions && questions.length > 0 ? (
        <div className="questions-list">
          {questions.map((item) => (
            <div key={item.id} className="question-item">
              <span className="question-text">{item.question}</span>
              <span className="question-count-badge">{item.count}</span>
            </div>
          ))}
        </div>
      ) : (
        <p className="no-data">No conversation data yet</p>
      )}
    </div>
  );
}

export default TopQuestions;